<div class="relative form-stepper flex">

  <div class="w-full bottom-0 h-4 progress-bar absolute z-0 rounded-full border-bl-4"></div>

  <div class="z-10 flex-grow"></div>

  @for (step of steps; track step; let last = $last) {
    <div class="z-10 flex flex-col w-40">
      <div [ngClass]="{ 'text-gray-400': step.state === StepStateOptions.UNCOMPLETED }"
        class="flex flex-grow  text-center leading-5 font-medium px-8 flex-col justify-center">
        {{ step.displayTitle }}
      </div>
      <div class="relative flex flex-grow-0 justify-center px-4 py-6"
        [ngClass]="{'cursor-pointer': isClickable(step.id) }"
        (click)="stepClicked(step.id)">
        <div class="absolute z-30 h-14 w-full flex items-center">
          <div [ngClass]="getStepClass(step.id)"  class="w-full" style=" height: 5px;"></div>
        </div>
        <div [ngClass]="getStepClass(step.id)" class="z-50 relative flex items-center justify-center font-medium  text-xl text-white rounded-full h-14 w-14">
          <fa-icon [icon]="step.icon" class="text-2xl"></fa-icon>
        </div>
      </div>
      <div [ngClass]="{'bg-white': step.state === StepStateOptions.UNCOMPLETED}" class="z-10 flex-grow-0 h-4 "></div>
    </div>
  }

  <div class="flex flex-col flex-grow">
    <div class="flex-grow"></div>
    <div class="z-10 flex-grow-0 h-4 rounded-r-full" [ngClass]="{'bg-white': !areStepsFinished() }"></div>
  </div>

</div>




